import './CountDown.css'
import React from 'react';
import CountDown from "./CountDown/CountDown.jsx";
import moment from 'moment';


export default class Countdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCountdown: true,
            deadLine: moment.utc('2023-05-23T12:00:00+03:00'),
            scroll: 0,
        }

        this.pageLink = window.location.href.toString();
        this.indexUtm = this.pageLink.indexOf('?');
        this.utm = this.pageLink.slice(this.indexUtm + 1);

        this.showCountdown = this.showCountdown.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    showCountdown() {
        this.setState({
            isCountdown: !this.state.isCountdown
        });
    }

    handleScroll() {
        this.setState({
            scroll: window.scrollY
        });
    }

    componentWillMount = () => {
        window.addEventListener("scroll", this.handleScroll);
        return () => window.removeEventListener("scroll", this.handleScroll);
    }

    render() {
        return (
            <React.Fragment>
                {moment().isBefore(this.state.deadLine) && this.state.scroll > 500 && <div>
                    {this.state.isCountdown && <div className='countdown-wrap'>
                        <div id="countdown" class="countdown">
                            <div class='countdown-content-block'>
                                <div class='countdown_text_block'>
                                    <p class='countdown-descr'>Don't miss out!</p>
                                    <p class='countdown-descr'>{`$100 >> $249 soon`}</p>
                                </div>
                                <CountDown futureDate={this.state.deadLine}></CountDown>
                                <a target='_blank' rel="noreferrer" class='countdown_btn' href={`https://geekle.us/ticket/1678202701282x255928117981085700?page=aisoftware${this.indexUtm !== -1 ? `&${this.utm}` : ''}`}>GET TICKET</a>
                            </div>
                            <img onClick={this.showCountdown} class='close_countdown' src='//s3.amazonaws.com/appforest_uf/f1628241276600x355310995010009720/Frame%2013.png' alt='' />
                        </div>
                    </div>}
                </div>}
            </React.Fragment>
        )
    }
}
